import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export const InsuranceCallout = ({ testid = "insurance-callout" }) => (
  <section className="py-16 md:py-20" data-testid={testid}>
    <div className="container-aviana max-w-4xl">
      <Link
        to="/journal/do-aerial-yoga-instructors-need-liability-insurance"
        className="group flex flex-col sm:flex-row sm:items-center gap-6 bg-aviana-cream border border-aviana-border rounded-[2rem] px-8 py-7 hover:border-aviana-gold hover:-translate-y-0.5 transition-[transform,border-color] duration-300"
        data-testid={`${testid}-link`}
      >
        <span className="flex-shrink-0 w-14 h-14 rounded-full bg-aviana-plumDeep text-aviana-goldSoft flex items-center justify-center">
          <ShieldCheck size={24} strokeWidth={1.5} />
        </span>
        <span className="flex-1">
          <span className="block font-display text-2xl text-aviana-ink mb-1">Insured to teach?</span>
          <span className="block text-aviana-muted text-[15px] leading-relaxed">
            Most studios require liability coverage before you lead your first aerial class. Here's what new instructors need to know.
          </span>
        </span>
        <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-aviana-plum group-hover:text-aviana-gold transition-colors whitespace-nowrap">
          Read the guide <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </span>
      </Link>
    </div>
  </section>
);

export default InsuranceCallout;
